export enum RequestedScanType {
    Front = 1 << 0,
    Back = 1 << 1,
    Selfie = 1 << 2,
    PassportBooklet = 1 << 3,
}

export function getRequestedScanTypeNames(requestedScanType: RequestedScanType): string {
    //loop through the members of RequestedScanType and return the names of the ones that are set pipe delimited
    const names = [];
    for (const type of getRequestedScanTypes(requestedScanType)) {
        names.push(RequestedScanType[type]);
    }
    return names.join('|');
}

export function getRequestedScanTypes(requestedScanType: RequestedScanType): RequestedScanType[] {
    const result: RequestedScanType[] = [];
    for (const enumMember in RequestedScanType) {
        const enumValue = Number(RequestedScanType[enumMember]);
        if (!isNaN(enumValue) && (requestedScanType & enumValue) === enumValue && enumValue !== 0) {
            result.push(enumValue);
        }
    }
    return result;
}

export type IDScanningSessionLog = {
    requestIdentifier?: string;
    token?: string;
    dealId: number;
    documentId: number;
    dealerId: number;
    requestedScanTypes?: RequestedScanType;
    requestedScanTypeNames?: string;
    allScansAttempted: boolean;
    allScansSuccessful: boolean;
    startTime: Date;
    uploadTime?: Date;
    uploadAttempted: boolean;
    scanAttempts?: IDScanLog[];
};

export type IDScanLog = {
    type: RequestedScanType;
    typeName: string;
    moduleName: string;
    startTime?: Date;
    endTime?: Date;
    elapsedMilliseconds?: number;
    result: IDScanResult;
    resultName?: string;
    data: any;
    dealerId: any;
    dealId: any;
    docId: any;
};

export enum IDScanResult {
    Success = 0,
    Fallback = 1,
    Timeout = 2,
    Error = 3,
    Back = 4,
    BrowserBack = 5,
}

/*
Flow: 
1. Click on drivers license
2. Create session object
    2a. OnBack in any scan component or on router navatigation
        2a1. Check for any scans -> If scan results, send to server
        2a2. If no scan results, do nothing
--- Scan Component Flow ---
1. Create session object
2. User Clicks Capture
    3a. Start creating scan log data
        3a1. Scan success -> send scan log to IntellicheckUploadComponent
            3a1a. User clicks continue -> done
            3a1b. User clicks retake -> go back to 3a
        3a2. Scan timeout -> send scan log to IntellicheckUploadComponent
            3a2a. User clicks take photo -> send stub scan log to IntellicheckUploadComponent on display preview
                3a2a1. User clicks continue -> done
                3a2a2. User clicks retake -> go back to 3a
        3a3. User clicks back during scan -> send scan log to IntellicheckUploadComponent -> wait for 2
4. User clicks back to documents at any point
    4a. Check for any scans -> If scan results, send to IntellicheckUploadComponent
    4b. If no scan results, do nothing
        





*/
